"use strict";

import angular from "angular";
import _ from "lodash";
import template from "./document-upload.component.html";
import "./themes/document-upload.component.scss";

/**
 * @component NuDocumentUpload
 * O <nu-document-upload> é um componente para importação de um ou mais documentos
 */

class NuDocumentUpload {
    constructor($scope, $mdDialog, DSNDialogService) {
        this.$scope = $scope;
        this.$mdDialog = $mdDialog;
        this.DSNDialogService = DSNDialogService;
        this.SIZE_LIMIT = 1500000;
    }
    $onInit() {
        this.heightBasedOnQuantityFiles = {
            height: "0",
            "max-height": "0"
        };
    }
    onSet = (files) => {
        if (!files.length) return null;
        if (files.length > 13 && this.hasDialog) this.openDialog();
        else this.onSetFiles(files);
    };
    onSetFiles = (files) => {
        this.files = files;
        if (_.isEmpty(this.files)) return null;
        const exceedsLimit = this.files.some((f) => f.size > this.SIZE_LIMIT);
        if (exceedsLimit) {
            this.findExceedsLimitAndRemove();
        } else {
            this.action(this.files);
            this.setHeightContainer(this.files);
        }
    };
    setHeightContainer = (files = this.files) => {
        this.calcHeight = 15 * files.length;
        this.heightBasedOnQuantityFiles.height = `${this.calcHeight}px`;
        this.heightBasedOnQuantityFiles["max-height"] = `${this.calcHeight}px`;
    };
    onRemoveFile = (index) => {
        const fileWasRemoved = this.files[index];
        this.remove(fileWasRemoved);
        this.files.splice(index, 1);
        this.setHeightContainer(this.files);
        if (_.isEmpty(this.files)) this.isDisabled = true;
    };
    findExceedsLimitAndRemove = () => {
        for (let i = 0; i < this.files.length; i++) {
            const file = this.files[i];
            if (file.size > this.SIZE_LIMIT) {
                this.files.splice(i, 1);
                this.openExceedsLimitDialog(file.name);
                break;
            }
        }
    };
    openDialog = () => {
        this.files = [];
        this.DSNDialogService.confirmation({
            locals: {
                title: " O limite de arquivos foi alcançado.",
                description: `
            Para que a leitura dos arquivos ocorra com sucesso, as importações se limitam a no máximo 12 balancetes e 1 planilha financeira.`,
                actions: {
                    confirm: {
                        label: "Ok!",
                        action: this.$mdDialog.hide
                    },
                    cancel: {
                        label: "Cancelar",
                        action: () => {
                            actionDialog();
                        }
                    }
                }
            }
        });
    };
    openExceedsLimitDialog = (fileName) => {
        const actionDialog = () => {
            this.$mdDialog.hide();
            this.onSetFiles(this.files);
        };
        this.DSNDialogService.confirmation({
            locals: {
                title: "Arquivo com tamanho incompatível!",
                description: `O arquivo ${fileName} é pesado demais para ser lido. Por favor, importe um novo arquivo menor que 1.5MB.`,
                width: "420px",
                actions: {
                    confirm: {
                        label: "Ok!",
                        action: () => {
                            actionDialog();
                        }
                    },
                    cancel: {
                        label: "Cancelar",
                        action: () => {
                            actionDialog();
                        }
                    }
                }
            }
        });
    };
}

NuDocumentUpload.$inject = ["$scope", "$mdDialog", "DSNDialogService"];

const name = "nuDocumentUpload";
const def = {
    bindings: {
        icon: "@",
        label: "@",
        fileType: "@",
        action: "=",
        remove: "=",
        multiple: "=",
        isDisabled: "=",
        hasDialog: "=",
        files: "="
    },
    controller: NuDocumentUpload,
    controllerAs: "documentUploadCtrl",
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
